<template>
  <c-flex direction="row" :mb="{ base: 'xl', md: '3xl' }">
    <c-box :d="{ base: 'none', md: 'block' }" mt="sm" mr="2xl">
      <c-icon v-if="isIloqMessage()" name="iloq_logo" size="3rem" color="brand.blue" />
      <c-icon v-else name="profile" size="3rem" color="gray.700" />
    </c-box>
    <c-box w="100%">
      <c-box
        d="inline-block"
        border-radius="base"
        box-shadow="0px 1px 10px 0px rgba(0, 0, 0, 0.1)"
        w="100%"
        width="auto"
        min-width="clamp(0px, 860px, 100%)"
        :px="{ base: 'xl', sm: '2xl', md: '3xl' }"
        :py="{ base: 'lg', md: '2xl' }"
        :background="shouldHighlightMessage ? 'brand.blueLightest' : 'white'"
      >
        <c-flex flex-direction="column">
          <c-text as="span" font-size="xs" color="#4b4b4b" :mb="{ base: 'sm', md: 'md' }">
            <c-heading
              as="h3"
              font-size="lg"
              font-weight="bold"
              color="brand.purple"
              d="inline-block"
              mr="md"
              mb="0"
            >
              {{ getName() }}
            </c-heading>

            <c-text as="span" d="inline-block" mr="lg" mb="0">
              {{ conversationItem.createdAt | moment("DD.MM.YYYY HH:mm") }}
            </c-text>
          </c-text>

          <c-box
            font-size="sm"
            color="text"
            v-chakra="{
              '.pp-field-label': {
                'font-weight': 'bold',
              },
            }"
          >
            <span v-html="conversationItem.bodyHtml" />
          </c-box>
          <c-box
            v-if="conversationItem.attachments && conversationItem.attachments.length"
            mt="lg"
            mb="-xs"
          >
            <c-flex
              v-for="attachment in conversationItem.attachments"
              v-bind:key="attachment.freshdeskId"
            >
              <DownloadSupportRequestAttachment
                :class="shouldHighlightMessage ? 'bg-blue' : ''"
                :ticket-id="$route.params.id"
                :message-id="
                  $route.params.id === conversationItem.id ? undefined : String(conversationItem.id)
                "
                :attachment-id="String(attachment.freshdeskId)"
                :attachment-name="attachment.name"
                :bg="shouldHighlightMessage ? 'gray.200' : 'brand.gray'"
              />
            </c-flex>
          </c-box>
        </c-flex>
      </c-box>
    </c-box>
  </c-flex>
</template>

<script lang="ts">
import DownloadSupportRequestAttachment from "@/components/solutions/DownloadSupportRequestAttachment.vue";
import Card from "@/design-system/elements/Card.vue";
import Icon from "@/design-system/elements/Icon.vue";
import { CBox, CFlex, CHeading, CIcon, CText } from "@chakra-ui/vue";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {
    CHeading,
    CBox,
    CIcon,
    CFlex,
    CText,
    Card,
    Icon,
    DownloadSupportRequestAttachment,
  },
  name: "SupportRequestChatCard",
  props: {
    conversationItem: Object as PropType<any>,
    shouldHighlightMessage: Boolean,
    isCurrentUsersMessage: Boolean,
  },
  methods: {
    isIloqMessage(): boolean {
      return this.conversationItem.email.indexOf("@iloq.") >= 0;
    },
    getName(): string {
      if (this.isCurrentUsersMessage) {
        return this.$t("tickets.you").toString();
      }

      if (this.isIloqMessage()) {
        if (this.conversationItem.name.indexOf("iLOQ") >= 0) {
          return this.conversationItem.name;
        }
        return `${this.conversationItem.name}, iLOQ`;
      }

      return this.conversationItem.name;
    },
  },
});
</script>
